import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { UsuariosService } from 'app/api/usuarios.service';
import { ClienteApiService } from 'app/api/clienteApi.service';
import { AlertModalService } from 'app/shared/alert-modal.service';
import { PessoaJuridica } from 'app/model/pessoaJuridica';
import { NewUser } from 'app/model/newUser';
import { SubSink } from 'subsink';

@Component({
  selector: 'app-usuarios-cadastrar',
  templateUrl: './usuarios-cadastrar.component.html',
  styleUrls: ['./usuarios-cadastrar.component.css']
})
export class UsuariosCadastrarComponent implements OnInit, OnDestroy {

  usuario: NewUser;
  clientes: PessoaJuridica[];
  addForm: FormGroup;
  submitted = false;

  private subs = new SubSink();

  constructor(
    private usuariosService: UsuariosService,
    private clienteService: ClienteApiService,
    private router: Router,
    private location: Location,
    private formBuilder: FormBuilder,
    private alertService: AlertModalService) { }

  ngOnInit() {
    this.getCliente() ;
    this.addForm = this.formBuilder.group({
      userName: ['', Validators.required],
      email: ['', [
        Validators.required,
        Validators.email
      ]],
      password: ['', Validators.required],
      pessoaJuridicaId: [0]
    });

    this.addForm.patchValue({ pessoaJuridicaId: null });

  }

  get f() { return this.addForm.controls; }

  validarEmail(email) {
    // Expressão regular básica para validar o formato do e-mail
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  }

  getCliente() {
    this.subs.sink = this.clienteService.v1ClienteGet()
    .subscribe(clientes => {
      this.clientes = clientes;
    });
  }

  cadastraUsuario(): void {
    if(this.addForm.get('email').value) {
      let checkEmail = this.validarEmail(this.addForm.get('email').value);
      if(!checkEmail) {
        this.alertService.showAlertDanger('O campo "E-mail" deve ter um e-mail válido.');
        document.getElementById('email').focus();
        return;
      }
    }

    this.submitted = true;
    if (this.addForm.invalid) { return; }
    this.subs.sink = this.usuariosService.v1UsuariosPost(this.addForm.value)
    .subscribe(success => {
      this.alertService.showAlertSuccess('Usuário cadastrado com sucesso!');
      this.router.navigate(['usuarios']);
    }, error => {
      console.error("Erro:", error);
      if (error?.Erros && Array.isArray(error.Erros) && error.Erros.length > 0) {
        this.alertService.showAlertDanger(error.Erros[0].Mensagem);
      } else {
        this.alertService.showAlertDanger('Erro ao cadastrar cliente.');
      }
    });
  }

  goBack(): void {
    this.location.back();
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }


}
